export default __webpack_public_path__ + "static/media/currency.15d972e0.svg";